import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 2 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 0,
    flexShrink: 0,
    width: "400px",
    // paddingLeft: '8px',
    // paddingRight: '8px',
    display: "flex",
    flexDirection: "column"
    // backgroundColor: theme.palette.background.paper,
  },
  tab: {
    minWidth: "70px"
  },
  tabs: {
    flexGrow: 0,
    flexShrink: 0
  }
}));

export default function TabPanel(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(props.active || 0);

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  return (
    <div className={classes.root}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="fullWidth"
        indicatorColor="primary"
        textColor="primary"
        className={classes.tabs}
      >
        {" "}
        {React.Children.map(props.children, element => {
          const { children, ...element_props } = element.props;
          return (
            <Tab
              className={classes.tab}
              disableRipple={true}
              {...element_props}
            />
          );
        })}
      </Tabs>
      {props.children[value]}
    </div>
  );
}

export function TabElement(props) {
  return props.children;
}
